import { addComponentEventHandlers } from "../../../assets/javascripts/lib/component_event_handler";

addComponentEventHandlers(".ui-kanban", (kanbanElement) => {
  // ドラッグ開始: タスクIDを転送データに設定
  kanbanElement.addEventListener("dragstart", (e) => {
    const task = e.target.closest(".task");
    if (!task) return;

    e.dataTransfer.setData("text/plain", task.dataset.taskId);
    e.dataTransfer.effectAllowed = "move";
    requestAnimationFrame(() => task.classList.add("dragging"));
  });

  // ドラッグ終了: ドラッグ中スタイルを解除
  kanbanElement.addEventListener("dragend", (e) => {
    const task = e.target.closest(".task");
    if (!task) return;

    task.classList.remove("dragging");
  });

  // ドラッグオーバー: ドロップを許可 & ハイライト
  kanbanElement.addEventListener("dragover", (e) => {
    const dropZone = e.target.closest(".column");
    if (!dropZone) return;

    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    dropZone.closest(".column").classList.add("drag-over");
  });

  // ドラッグリーブ: ハイライト解除
  kanbanElement.addEventListener("dragleave", (e) => {
    const dropZone = e.target.closest(".column");
    if (!dropZone) return;

    // relatedTarget がドロップゾーン内にある場合はハイライトを維持
    if (dropZone.contains(e.relatedTarget)) return;

    dropZone.closest(".column").classList.remove("drag-over");
  });

  // ドロップ: タスクを移動してサーバーに通知
  kanbanElement.addEventListener("drop", (e) => {
    const column = e.target.closest(".column");
    if (!column) return;

    e.preventDefault();

    column.classList.remove("drag-over");

    const taskId = e.dataTransfer.getData("text/plain");
    const task = kanbanElement.querySelector(`.task[data-task-id="${taskId}"]`);
    if (!task) return;

    // DOM上でタスクを移動（即時の視覚フィードバック）
    const tasks = column.querySelector(".tasks");
    tasks.appendChild(task);

    // htmx でサーバーへ通知（URLが設定されている場合のみ）
    const url = kanbanElement.getAttribute("data-hx-post");
    if (url && typeof htmx !== "undefined") {
      htmx.ajax("POST", url, {
        target: kanbanElement,
        swap: "outerHTML",
        values: {
          task_id: taskId,
          column: column.dataset.columnId,
        },
      });
    }
  });
});
